import { render, staticRenderFns } from "./editLevel.vue?vue&type=template&id=2afa901b"
import script from "./editLevel.vue?vue&type=script&lang=js"
export * from "./editLevel.vue?vue&type=script&lang=js"
import style0 from "./editLevel.vue?vue&type=style&index=0&id=2afa901b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports